<template>
    <div class="flex items-center gap-2">
        <p v-if="tags.length > 0" :title="tags[0]"  class="px-3 py-2 rounded-md text-14px font-medium transition-colors truncate max-w-8"
            :class="getTagStyle()">
            {{ tags[0] }}
        </p>
        <p v-if="tags.length > 2" :title="tags[1]" class="px-3 py-2 rounded-md text-14px font-medium transition-colors truncate max-w-8"
            :class="getTagStyle()">
            {{ tags[1] }}
        </p>
        <p v-if="tags.length === 2" :title="tags[1]" class="px-3 py-2 rounded-md text-14px font-medium transition-colors truncate max-w-8"
            :class="getTagStyle()">
            {{ tags[1] }}
        </p>
        <p v-if="tags.length > 2" :title="tags.length - 2" class="px-3 py-2 rounded-md text-14px font-medium transition-colors truncate max-w-8"
            :class="getTagStyle()"
            @mouseover="showTooltip = true; tooltipPosition = {x: $event.clientX, y: $event.clientY}"
            @mouseleave="showTooltip = false">
            +{{ tags.length - 2 }}
        </p>
        <div v-if="showTooltip && tags.length > 2" 
          class="fixed z-[999999] bg-white text-gray-800 text-14px rounded-lg p-4 shadow-xl border border-gray-200 max-w-xs pointer-events-none"
          :style="{
            left: tooltipPosition.x + 'px',
            top: tooltipPosition.y + 'px',
            transform: 'translateX(-50%) translateY(-100%)'
          }"
        >
          <div class="font-semibold mb-2 text-gray-900">All tags:</div>
          <div class="space-y-1">
            <div v-for="(tag, index) in tags" :key="index" class="text-gray-700">
              • {{ tag }}
            </div>
          </div>
          <div 
            class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white"
          />
        </div>
    </div>
</template>

<script>
export default {
    name: "Tag",
    props: {
        tags: {
            type: Array,
            default: () => []
        },
        color: {
            type: String,
            default: 'blue'
        }
    },
    data() {
        return {
            showTooltip: false,
            tooltipPosition: { x: 0, y: 0 }
        }
    },
    methods: {
        getTagStyle() {
            const colorMap = {
                'blue': 'bg-blue-200 text-blue-800',
                'green': 'bg-green-200 text-green-800',
                'red': 'bg-red-200 text-red-800',
                'gray': 'bg-gray-200 text-gray-800'
            }
            const colorScheme = colorMap[this.color];
            return colorScheme;
        }
    }
}
</script>

<style scoped>
.text-14px {
    font-size: 14px;
}
.max-w-8 {
    max-width: 8rem;
}
</style>
